import React, { useMemo } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { useTiktokShop } from '@/tiktok-platform/context/TiktokShopContext';
import '@/styles/ipe/workbench/PlatformProductManagePage.css';
import '@/styles/tiktok-platform/tiktok-product-ops.css';

/**
 * 产品管理内容壳：页头已去掉，二级菜单在侧栏，此处只承载主内容。
 */
export default function TiktokProductOpsLayout() {
  const { activeShop } = useTiktokShop();
  const shopLabel = useMemo(
    () => activeShop?.shopName || '未选择店铺',
    [activeShop],
  );

  return (
    <div className="tiktok-product-ops tiktok-product-ops--wide" data-testid="tiktok-product-ops">
      <div className="tiktok-product-ops__workspace">
        <div className="tiktok-product-ops__content tiktok-product-ops__content--flush">
          <Outlet context={{ shopLabel }} />
        </div>
      </div>
    </div>
  );
}

export function useProductOpsContext() {
  return useOutletContext() || {};
}
